export default __webpack_public_path__ + "static/media/than.4edb8937.svg";